import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Cursor from "./components/Cursor";
import ThreeBackground from "./components/ThreeBackground";
import GsapInit from "./components/GsapInit";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";

function App() {
  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <Router>
      <div style={{ background: '#050505', color: '#fff', minHeight: '100vh' }}>
        <Cursor />
        <ThreeBackground />
        <GsapInit />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
        {/* Spacer so content scrolls above fixed footer */}
        <div style={{ height: '300px', background: 'transparent', pointerEvents: 'none' }} />
        <Footer />
      </div>
    </Router>
  );
}

export default App;

